/**
 * 语言包 - 简体中文
 * 支持按照组件区分命名空间:
 * {
 *   key: value,
 *   noticeBar: {
 *     key: value
 *   }
 * }
 */
export default {};
